<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleAddonPopup()">
			<div class="featherlight-content" id="addons" >
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleAddonPopup()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">
						<h2>{{ addons.length == 1 ? 'Add another activity' : 'Add more activities' }}</h2>
						<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
							<template v-if="typeof errors == 'string'">
								<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>{{ errors }}</span></p>
							</template>
							<template v-else>
								<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please check the errors below and try again.</span></p>
							</template>
						</template>
						<p>Consider adding another activity to your package from the list below. Once chosen, it will be instantly added to your itinerary, and the price will be updated accordingly. If you have a preferred day or time for this addition, please leave a note on your message board.</p>
						<div class="addon_item" v-for="(item) in addons">
							<div class="image">
								<img :src="item.thumb" :alt="item.item_name">
							</div>
							<div class="details">
								<p><b>{{ item.item_name }}</b></p>
								<p class="price" :style="'--accent:' + accent">{{ formatCurrency(getPrice(item.item_price, item.price_type)) }} per person</p>
								<p v-if="item.excerpt">{{ nl2br(item.excerpt) }}</p>

								<template v-if="item.more_info">
									<button type="button" class="button small solid" :data-featherlight="'/ajax/activity-details/' + item.activity_id" data-featherlight-after-open="doActivitySlickInPopup()">
										<span class="fa-stack fa-1x">
											<i class="fal fa-circle fa-stack-2x"></i>
											<i class="fas fa-info fa-stack-1x"></i>
										</span>
										More Info
									</button>
								</template>

							</div>
							<div class="select" :style="'--accent:' + accent">
								<input type="checkbox" v-model="selected_addons" :value="item.id">
							</div>
						</div>

						<div class="addon_summary">
							<div class="constraint">
								<p>
									<b>{{ selected_addons.length }}</b> <template v-if="selected_addons.length==1">activity</template><template v-else>activities</template> selected
									<br>
									Extra per person: <b>{{ formatCurrency(extra_price) }}</b>
								</p>
								<button type="button" class="button small solid" :style="'--accent:' + this.accent" :disabled="button_disabled" v-on:click="postAddons()">
									<span class="fa-stack fa-1x">
										<i class="fas fa-paper-plane fa-stack-2x"></i>
									</span>
									Add Activities
								</button>
								
							</div>
						</div>

					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
		'accent',
		'uuid',
		'base_participants'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			addons: {},
			selected_addons: [],
			errors: [],
			shouldShow: false,
			extra_price: 0
		}
	},

	computed: {
		button_disabled: function () {
			if (this.selected_addons.length == 0) {
				return true;
			} else {
				return false;
			}
		}
	},

	watch: {
		selected_addons: function (value) {
			this.calculatePrice();
		}
	},

	created() {
	},

	mounted() {
		this.getAddons();
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleAddonPopup: function(){
			if(this.shouldShow==true) {
				this.shouldShow = false;
				this.success = false;
				this.errors = [];

			}else{
				this.shouldShow = true;
				// this.$nextTick(function() {
				// 	this.getAddons();
				// });
			}
		},

		getAddons: function() {
			axios.post('/ajax/getAddons', {
				uuid: this.uuid
			})
			.then(response => {
				this.addons = response.data;
			})
			.catch(error => {
				var errors = error.response.data['errors'];
				this.errors = errors;
			});
		},

		postAddons: function () {
			axios.post('/ajax/postAddons', {
				uuid: this.uuid,
				selected_addons: this.selected_addons
			})
			.then(response => {
				if(response.data.status=='success') {
					this.toggleAddonPopup();
					var self = this;
					setTimeout(function() {
						self.alert("<strong>Great!</strong> Your booking has been updated", 'success')
					}, 500);
					setTimeout(function() {
						// redirect to proper account page
						window.location.href = "/account/bookings/" + response.data.reference;
					}, 2000);
				}else{
					this.errors = response.data['errors'];
					document.getElementById('addons').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('addons').scrollIntoView({behavior: "smooth"});
				}
			});
		},

		calculatePrice: function () {
			var price = 0;
			for (var key in this.addons) {
				if (this.selected_addons.includes(this.addons[key].id)) {
					price += parseFloat(this.getPrice(this.addons[key].item_price, this.addons[key].price_type));
				}
			}
			this.extra_price = price;
		},

		getPrice: function (price, price_type) {
			if (isNaN(price)) {
				return 0 + price;
			}else{
				if (price_type == 'pp') {
					return 0 + price;
				} else {
					return 0 + (Math.round((price / this.base_participants) * 100) / 100);
				}
			}
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

		nl2br: function (str, is_xhtml) {
			if (typeof str === 'undefined' || str === null) {
				return '';
			}
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		},

		formatCurrency: function (value) {
			return "£" + this.numberWithCommas((Math.round( (parseFloat(value) + 0.0001) * 100 ) / 100).toFixed(2));
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

	}
};
</script>